"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fraktur = void 0;
var FontData_js_1 = require("../../FontData.js");
var fraktur_js_1 = require("../../../common/fonts/tex/fraktur.js");
exports.fraktur = (0, FontData_js_1.AddCSS)(fraktur_js_1.fraktur, {
    0x2044: { c: '/' },
});
//# sourceMappingURL=fraktur.js.map